import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataService {
  public Param: any;
  public Params: any = [];
  public ParamObj: any = {};
  public userProfile: any = null;
  public userAccess: any = null;

  private _errorRespond = new BehaviorSubject<any>(null);
  errorRespond = this._errorRespond.asObservable();

  updateErrorRespond(error: any) {
    this._errorRespond.next(error)
  }
  filterBusinessGroup(groupType: string, parentGroup: string, filterValue: number) {
    return this.userAccess.filter((i: any, index: any, self: any) =>
      index === self.findIndex((t: any) => (
        t[groupType] === i[groupType] && i[parentGroup] == filterValue
      ))
    )
  }
}